export type UnlistenFn = () => void;

export const onceSafeUnlisten = (
  // Tauri types its unlisten `() => void` but really returns a promise that
  // rejects on the `listeners[eventId].handlerId` webview-reload race.
  unlisten: () => void | Promise<void>,
  onAlreadyRemoved: (error: unknown) => void
): UnlistenFn => {
  let called = false;
  return () => {
    if (called) return;
    called = true;
    void (async () => {
      try {
        await unlisten();
      } catch (error) {
        onAlreadyRemoved(error);
      }
    })();
  };
};
